module.exports = __webpack_public_path__ + "static/img/xinxitou.0ce57847.png";